export default class GoogleMaps {
    constructor() {
        this._items = Array.from(document.querySelectorAll('.acf-map'));
        this.gmapsStyle = [
            { featureType: 'poi.business', stylers: [{ visibility: 'off' }] },
            { featureType: 'poi.park', elementType: 'labels.text', stylers: [{ visibility: 'off' }] },
        ];
    }
    render() {
        if (this._items.length) {
            this._items.forEach((item) => {
                this.setupMap(item);
            });
        }
    }
    setupMap(element) {
        const markers = Array.from(element.querySelectorAll('.marker'));
        // Create gerenic map.
        const mapArgs = {
            zoom: parseInt(element.getAttribute('data-zoom')) || 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scaleControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            styles: this.gmapsStyle,
        };
        let map = new google.maps.Map(element, mapArgs);
        map.markers = [];
        markers.forEach((marker) => {
            this.initMarker(marker, map);
        });
        this.centerMap(map);
        return map;
    }

    initMarker($marker, map) {
        const lat = $marker.getAttribute('data-lat');
        const lng = $marker.getAttribute('data-lng');
        const latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
        };
        // Create marker instance.
        const marker = new google.maps.Marker({
            position: latLng,
            map: map,
        });
        // Append to reference for later use.
        map.markers.push(marker);
        // If marker contains HTML, add it to an infoWindow.
        if ($marker.innerHTML.length > 0) {
            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.innerHTML,
            });
            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(map, marker);
            });
        }
    }

    centerMap(map) {
        // Create map boundaries from all map markers.
        let bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function (marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng(),
            });
        });
        // Case: Single marker.
        if (map.markers.length == 1) {
            map.setCenter(bounds.getCenter());
            // Case: Multiple markers.
        } else {
            map.fitBounds(bounds);
        }
    }
}
